export const estadoCivil = [
    { value: '1', text: 'Casado', text2: 'C' },
    { value: '2', text: 'Soltero', text2: 'S' },
    { value: '3', text: 'Divorciado', text2: 'D' },
    { value: '4', text: 'Viudo', text2: 'V' },
];

export const tipoDocumentos = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' },
]

export const sexo = [
    { value: '1', text: 'Femenino', text2: 'F' },
    { value: '2', text: 'Masculino', text2: 'M' },
];

export const nacionalidad = [
    { value: '1', text: 'AMERICA DEL NORTE' },
    { value: '2', text: 'CANADA' },
    { value: '3', text: 'ESTADOS UNIDOS' },
    { value: '4', text: 'MEXICO' },
    { value: '5', text: 'CENTROAMERICA' },
    { value: '6', text: 'GUATEMALA' },
    { value: '7', text: 'EL SALVADOR' },
    { value: '8', text: 'HONDURAS' },
    { value: '9', text: 'FINLANDIA' },
    { value: '10', text: 'ISRAEL' },
    { value: '11', text: 'REPUBLICA DE SUR' },
    { value: '12', text: 'AMERICA DEL SU' },
    { value: '13', text: 'VENEZUELA' },
    { value: '505', text: 'NICARAGUA' },
];


export const profesion = [
    { value: '4', text: 'ACTUARIO' },
    { value: '2', text: 'ADMINISTRADOR COMERCIAL' },
    { value: '11', text: 'INGENIERO EN SISTEMAS' },
];
export const ocupacion = [
    { value: '1', text: 'ABARROTERO' },
    { value: '2', text: 'ABASTOS, BODEGAS, DELICATESES.' },
    { value: '3', text: 'ABOGADO' },
    { value: '4', text: 'ABONOS Y FERTILIZANTES VENTAS.' },
    { value: '5', text: 'ABRASIVO (MANEJO, SILICE NO, OTROS ABRASIVOS)' },
];

export const actividad = [
    { value: '1', text: 'EMPLEADO' },
    { value: '3', text: 'PROPIETARIO DE NEGOCIO' },
    { value: '4', text: 'ESTUDIANTE' },
    { value: '5', text: 'AMA DE CASA' },
];

export const origenFondo = [
    { value: '1', text: 'SALARIO' },
    { value: '2', text: 'HERENCIA' },
    { value: '3', text: 'AHORRO' },
    { value: '4', text: 'EMPRESA' },
    { value: '5', text: 'OTROS' },
];

export const monedas = [
    { value: '1', text: 'Córdobas' },
    { value: '2', text: 'Dólares' },
];

export const estaturaUnidades = [
    { value: '1', text: 'Metros' },
    { value: '2', text: 'Centimetros' },
];

export const pesoUnidades = [
    { value: '1', text: 'Libras' },
    { value: '2', text: 'Kg' },
];

export const SAs = [
    { value: '10000', text: '10,000.00' },
    { value: '20000', text: '20,000.00' },
    { value: '50000', text: '50,000.00' },
    { value: '75000', text: '75,000.00' },
    { value: '100000', text: '100,000.00' },
];

export const frecuenciaPagos = [
    { value: '1', text: 'Anual' },
    { value: '2', text: 'Semestral' },
    { value: '4', text: 'Trimestal' },
    { value: '12', text: 'Mensual' }
];



export const parentescos = [
    { value: '10', text: 'Sobrino (a)' },
    { value: '13', text: 'Esposo' },
    { value: '14', text: 'Esposa' },
    { value: '16', text: 'Albacea' },
    { value: '19', text: 'Nieto (a)' },
    { value: '20', text: 'Novio (a)' },
    { value: '21', text: 'Hijastra' },
    { value: '24', text: 'Pareja' },
    { value: '25', text: 'Ex-Esposa' },
    { value: '27', text: 'Prima (o)' },
    { value: '28', text: 'Mama De Crianza' },
    { value: '3', text: 'Padre' },
    { value: '30', text: 'Bisabuela' },
    { value: '31', text: 'Madrina' },
    { value: '35', text: 'Nuera' },
    { value: '37', text: 'Exconyuge' },
    { value: '39', text: 'Padrino' },
    { value: '4', text: 'Madre' },
    { value: '41', text: 'Madrasta' },
    { value: '42', text: 'Padrasto' },
    { value: '43', text: 'Hijastro' },
    { value: '5', text: 'Cuñado (a)' },
    { value: '6', text: 'Suegro (a)' },
    { value: '7', text: 'Tio (a)' },
    { value: '8', text: 'Abuelo (a)' },
    { value: '9', text: 'Hermano (a)' },
    { value: 'E', text: 'Conyuge' },
    { value: 'H', text: 'Hijo (a)' },
];




export const poseeCorreduria = [
    { value: 'SI', text: 'Si' },
    { value: 'NO', text: 'No' },
];


export const motivoRechazoCICAC = [
    { value: '2', text: 'Cliente que no tiene firma digital y vive en extranjero' },
    { value: '3', text: 'Cliente que no desea que su información esté en otras bases de datos' },
    { value: '4', text: 'Otros' },
];